
import { defineComponent, reactive, toRefs } from 'vue';
import Overlay from '../../components/Overlay.vue';
import VChart from 'vue-echarts';

export default defineComponent({
  name: 'DashboardAllocatedAccomlpished',

  components: {
    Overlay,
    VChart,
  },

  props: {
    projectedAccumulated: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    newChannelBudgetQtde: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    channelRevenueQtdeAccumulated: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    channelBudgetQtdeAccumulated: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    day: {
      type: Array as () => Array<string>,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const propsRef = toRefs(props);
    const state = reactive({
      options: {
        backgroundColor: '#404040',
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '2%',
          top: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: propsRef.day,
          axisLine: { show: true },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
        },
        yAxis: {
          type: 'value',
          position: 'right',
          axisLine: { show: false },
          axisLabel: { show: true },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
        },
        series: [
          {
            name: 'Meta acumulada',
            type: 'line',
            data: propsRef.channelBudgetQtdeAccumulated,
            color: '#143168',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
          {
            name: 'Projetado acumulado',
            type: 'line',
            data: propsRef.projectedAccumulated,
            color: '#f56224',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
          {
            name: 'Realizado acumulado',
            type: 'line',
            data: propsRef.channelRevenueQtdeAccumulated,
            color: '#e6ea00',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
        ],
      },
    });
    return { ...toRefs(state) };
  },
});
